import { axios, Response } from '../index'
import { Post } from './get-post-by-id'

const getUserFixedPost = (): Response<Post[]> => {
  return axios.get(`/v1/personas/posts/pinned`, {})
}

export default getUserFixedPost
